import graphql__c9dae866ef25f4d41532 from "./__generated__/HeaderManagerQuery.graphql.js";import { graphql } from "react-relay";

import AppQueryRenderer from "../AppQueryRenderer";
import Header from "./Header";

const HeaderManager = props => {
  return (
    <AppQueryRenderer
      query={HeaderManagerQuery}
      component={Header}
      additionalProps={props}
      handleErrors={false}
    />
  );
};

const HeaderManagerQuery = graphql__c9dae866ef25f4d41532;

export default HeaderManager;
